/*
 * VIOSSI — сервисные строки корзины: Shipping Protection и Free Returns.
 *
 * Заменяют два сторонних виджета:
 *   • Navidium (страховка доставки) — снят из темы 04.08.2026;
 *   • re:do (возвраты) — их блоки в футере дровера («Info Card» + пара кнопок
 *     «Checkout +») больше не монтируются: якорь
 *     `[class="cart-drawer__footer"]>.button-group` сломан вторым классом формы.
 *     Товар покрытия и атрибут опт-ина остались ИХ — система re:do видит заказ
 *     как свой.
 *
 * Две разные механики, и это осознанно:
 *
 *   ЗАЩИТА ДОСТАВКИ — строка ЖИВЁТ В КОРЗИНЕ (как делал Navidium). Значит
 *   Total и цифра в кнопке чекаута всегда честные, а тир пересчитывается при
 *   каждом изменении корзины — ровно то, чего не умел Navidium (июль: 8 заказов
 *   недобрали $82, #13806 $800 → fee $16.50 вместо $32).
 *
 *   ВОЗВРАТЫ — строка добавляется в момент перехода в чекаут, как в их
 *   attachmentStrategy=checkout-button-product. Держать её в корзине нельзя:
 *   их скрипт стор-уровневый и вычищает свой товар из корзины сам.
 */
(function () {
  'use strict';

  var cfg = null;
  var lastCart = null;
  var queue = Promise.resolve();
  var syncing = false;
  var paintingCount = false;

  /* ------------------------------------------------------------------ *
   * Конфиг и утилиты
   * ------------------------------------------------------------------ */
  function config() {
    if (cfg !== null) {
      return cfg || null;
    }
    var el = document.querySelector('[data-cart-services-config]');
    if (!el) {
      cfg = false;
      return null;
    }
    try {
      var raw = JSON.parse(el.textContent);
      var protection = raw.protection || {};
      var redo = raw.redo || {};
      cfg = {
        pageType: raw.pageType || '',
        protection: protection.pid && (protection.tiers || []).length
          ? {
              pid: protection.pid,
              pct: protection.pct || 4,
              attr: protection.attr || 'protection_opted_in_from_cart',
              exclude: (protection.exclude || []).filter(Boolean),
              disclaimer: protection.disclaimer || '',
              tiers: protection.tiers
                .map(function (row) {
                  return { price: parseInt(row[0], 10) || 0, id: parseInt(row[1], 10) || 0 };
                })
                .filter(function (t) { return t.price > 0 && t.id; })
                .sort(function (a, b) { return a.price - b.price; })
            }
          : null,
        redo: redo.pid && redo.targetId
          ? {
              pid: redo.pid,
              attr: redo.attr || 'redo_opted_in_from_cart',
              available: !!redo.available,
              target: { id: redo.targetId, price: redo.targetPrice || 0 }
            }
          : null
      };
    } catch (err) {
      cfg = false;
    }
    return cfg || null;
  }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* Висящий запрос без таймаута = бесконечно «занятая» корзина. */
  function timeoutSignal(ms) {
    return typeof AbortSignal !== 'undefined' && AbortSignal.timeout ? AbortSignal.timeout(ms || 10000) : undefined;
  }

  /* no-store обязателен: браузер спокойно отдаёт /cart.js из своего кэша, и
     тогда мы красим корзину по состоянию ДО собственной записи — тумблер
     отскакивает обратно. */
  function getCart() {
    return fetch(root() + 'cart.js', {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
      signal: timeoutSignal()
    }).then(
      function (r) {
        if (!r.ok) {
          throw new Error('cart.js ' + r.status);
        }
        return r.json();
      }
    );
  }

  /* Отказ корзины (404 на снятый вариант, 422 на недоступный) не должен ронять
     страницу, но обязан быть виден в консоли: молчаливая потеря строки ровно
     так и выглядит — заказ прошёл, покрытия нет. */
  function postCart(path, body) {
    return fetch(root() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
      signal: timeoutSignal()
    }).then(function (r) {
      if (r.ok) {
        return r.json();
      }
      return r
        .json()
        .catch(function () { return null; })
        .then(function (data) {
          var message = (data && (data.description || data.message)) || r.status;
          if (window.console) {
            console.warn('[cart-services] ' + path + ' rejected', message);
          }
          throw new Error('cart-services ' + path + ' ' + r.status);
        });
    });
  }

  function moneyFormat(kind) {
    var vars = (window.themeVariables && window.themeVariables.settings) || {};
    var format = kind === 'currency'
      ? vars.moneyWithCurrencyFormat || vars.moneyFormat
      : vars.moneyFormat;
    return format || null;
  }

  function formatMoney(cents, kind) {
    var format = moneyFormat(kind);
    if (!format) {
      return '$' + (cents / 100).toFixed(2);
    }
    /* shop.money_format у этого магазина приходит с разметкой
       (<span class=money>…</span>) — в textContent она вылезла бы текстом. */
    return format.replace(/<[^>]*>/g, '').replace(/\{\{\s*(\w+)\s*\}\}/g, function (_m, name) {
      var value = cents / 100;
      switch (name) {
        case 'amount_no_decimals':
        case 'amount_no_decimals_with_comma_separator':
          return String(Math.round(value));
        case 'amount_with_comma_separator':
          return value.toFixed(2).replace('.', ',');
        default:
          return value.toFixed(2);
      }
    });
  }

  /* ------------------------------------------------------------------ *
   * Строки корзины
   * ------------------------------------------------------------------ */
  function linesOf(cart, pid) {
    if (!pid || !cart || !cart.items) {
      return [];
    }
    return cart.items.filter(function (item) { return item.product_id === pid; });
  }

  function protectLines(cart) {
    var c = config();
    return c && c.protection ? linesOf(cart, c.protection.pid) : [];
  }

  function redoLines(cart) {
    var c = config();
    return c && c.redo ? linesOf(cart, c.redo.pid) : [];
  }

  function serviceQty(cart) {
    var sum = 0;
    protectLines(cart).concat(redoLines(cart)).forEach(function (it) { sum += it.quantity; });
    return sum;
  }

  /* База процента = корзина без служебных строк: страховки и возвратов.
     Зеркало snippets/cart-protection-target.liquid. */
  function merchBase(cart) {
    var c = config();
    if (!c || !c.protection || !cart) {
      return 0;
    }
    var base = cart.total_price || 0;
    (cart.items || []).forEach(function (item) {
      if (item.product_id === c.protection.pid || c.protection.exclude.indexOf(item.product_id) !== -1) {
        base -= item.final_line_price;
      }
    });
    return base > 0 ? base : 0;
  }

  function targetTier(cart) {
    var c = config();
    if (!c || !c.protection) {
      return null;
    }
    var fee = Math.floor((merchBase(cart) * c.protection.pct) / 100);
    var tiers = c.protection.tiers;
    for (var i = 0; i < tiers.length; i++) {
      if (tiers[i].price >= fee) {
        return tiers[i];
      }
    }
    return tiers[tiers.length - 1];
  }

  function attrOf(cart, name) {
    return ((cart && cart.attributes) || {})[name];
  }

  /* Страховка: дефолт ВКЛЮЧЕНА, отказ пишется строкой 'false'.
     Наличие строки согласием не считаем — она лежит в корзине постоянно, и
     такая эвристика сделала бы отказ невыполнимым. */
  function protectOptedIn(cart) {
    var c = config();
    return !!(c && c.protection) && attrOf(cart, c.protection.attr) !== 'false';
  }

  /* Возвраты: дефолт ВЫКЛЮЧЕНЫ, согласие пишется строкой 'true'. */
  function redoOptedIn(cart) {
    var c = config();
    if (!c || !c.redo) {
      return false;
    }
    return attrOf(cart, c.redo.attr) === 'true' || redoLines(cart).length > 0;
  }

  /* ------------------------------------------------------------------ *
   * Намерение покупателя
   * ------------------------------------------------------------------ *
   * Щелчок по тумблеру — это факт, а состояние корзины подтягивается за ним
   * с задержкой. Между щелчком и подтверждением по странице ходит сразу
   * несколько источников правды: перерисовка секции дровера с сервера, наши
   * же обработчики cart:change/cart:refresh, кэш браузера и чужой скрипт
   * re:do, который тоже пишет атрибуты корзины. Любой из них, придя со старым
   * снимком, перекрашивал галку обратно — «тумблер сам возвращается».
   *
   * Поэтому до подтверждения главный — выбор покупателя. Если сервер трижды
   * говорит обратное, один раз переписываем атрибут (кто-то затёр), и только
   * потом сдаёмся и показываем правду — врать про покрытие нельзя.
   */
  /* Выбор ЛИПКИЙ: он живёт до следующего щелчка покупателя, а не до первого
     подтверждения. Иначе достаточно одного затирания атрибута кем-то ещё
     (или ответа /cart.js из кэша) — и галка отскакивает уже после того, как
     мы «убедились», что всё хорошо.

     Расхождение чиним записью атрибута, но не бесконечно: 3 попытки на выбор
     и 8 на страницу. Если чужой скрипт всё равно перебивает — сдаёмся и
     показываем правду, потому что врать про покрытие нельзя. */
  var intent = { protect: null, redo: null };
  var intentFixes = { protect: 0, redo: 0 };
  var FIX_LIMIT = 3;
  var FIX_BUDGET = 8;
  var fixBudget = FIX_BUDGET;

  function desiredProtect(cart) {
    return intent.protect !== null ? intent.protect : protectOptedIn(cart);
  }

  function desiredRedo(cart) {
    return intent.redo !== null ? intent.redo : redoOptedIn(cart);
  }

  function reconcile(cart) {
    var c = config();
    if (!c || !cart) {
      return;
    }
    if (intent.protect !== null && c.protection) {
      if (protectOptedIn(cart) === intent.protect) {
        intentFixes.protect = 0;
      } else if (intentFixes.protect < FIX_LIMIT && fixBudget > 0) {
        intentFixes.protect += 1;
        fixBudget -= 1;
        writeAttr(c.protection.attr, intent.protect ? 'true' : 'false');
      } else {
        if (window.console) {
          console.warn('[cart-services] выбор покрытия перебивает кто-то ещё — показываем состояние корзины');
        }
        intent.protect = null;
        intentFixes.protect = 0;
      }
    }
    if (intent.redo !== null && c.redo) {
      if (redoOptedIn(cart) === intent.redo) {
        intentFixes.redo = 0;
      } else if (intentFixes.redo < FIX_LIMIT && fixBudget > 0) {
        intentFixes.redo += 1;
        fixBudget -= 1;
        writeAttr(c.redo.attr, intent.redo ? 'true' : 'false');
      } else {
        if (window.console) {
          console.warn('[cart-services] выбор возвратов перебивает кто-то ещё — показываем состояние корзины');
        }
        intent.redo = null;
        intentFixes.redo = 0;
      }
    }
  }

  /* ------------------------------------------------------------------ *
   * Отрисовка
   * ------------------------------------------------------------------ */
  function paint(cart) {
    var c = config();
    if (!c) {
      return;
    }

    if (c.protection) {
      var on = desiredProtect(cart);
      var tier = targetTier(cart);
      var rows = document.querySelectorAll('[data-cart-protect]');
      for (var i = 0; i < rows.length; i++) {
        var input = rows[i].querySelector('[data-protect-toggle]');
        if (input && input.checked !== on) {
          input.checked = on;
        }
        var price = rows[i].querySelector('[data-protect-price]');
        if (price && tier) {
          price.textContent = formatMoney(tier.price, 'plain');
        }
        rows[i].classList.toggle('is-on', on);
      }
    }

    if (c.redo) {
      var redoOn = desiredRedo(cart);
      var redoRows = document.querySelectorAll('[data-cart-returns]');
      for (var j = 0; j < redoRows.length; j++) {
        var redoInput = redoRows[j].querySelector('[data-returns-toggle]');
        if (redoInput && redoInput.checked !== redoOn) {
          redoInput.checked = redoOn;
        }
        redoRows[j].classList.toggle('is-on', redoOn);
      }
    }

    paintTotals(cart);
    paintCounts(cart);
  }

  /* Сумма, которую видит покупатель. Зеркало snippets/cart-display-total —
     держать в локстепе.

     Страховка уже лежит в корзине строкой, а покрытие возвратов кладётся
     только на переходе в чекаут (их модель). Без этой добавки тумблер
     возвратов щёлкал бы, а сумма стояла на месте. */
  function displayTotal(cart, base) {
    var c = config();
    var value = base === 'subtotal' && cart.items_subtotal_price != null
      ? cart.items_subtotal_price
      : cart.total_price;
    if (c && c.redo && desiredRedo(cart) && !redoLines(cart).length) {
      value += c.redo.target.price;
    }
    return value;
  }

  /* Сервер отрисовал суммы до нашей записи в корзину: дровер тема перерисует
     сама, а страница /cart — нет, она обновляется только навигацией. Поэтому
     правим по меткам из sections/main-cart и sections/cart-drawer. */
  function paintTotals(cart) {
    if (!cart || typeof cart.total_price !== 'number') {
      return;
    }
    var totals = document.querySelectorAll('[data-cart-total]');
    for (var i = 0; i < totals.length; i++) {
      totals[i].textContent = formatMoney(displayTotal(cart, 'total'), totals[i].getAttribute('data-cart-total'));
    }
    var subtotals = document.querySelectorAll('[data-cart-subtotal]');
    for (var j = 0; j < subtotals.length; j++) {
      subtotals[j].textContent = formatMoney(
        displayTotal(cart, 'subtotal'),
        subtotals[j].getAttribute('data-cart-subtotal')
      );
    }
  }

  /* Счётчик в шапке приходит из cart.item_count и считает служебные строки.
     Liquid вычитает их на серверном рендере, здесь — после обновлений темы
     (их обработчик асинхронный, поэтому ещё и MutationObserver ниже). */
  function paintCounts(cart) {
    if (!cart || typeof cart.item_count !== 'number') {
      return;
    }
    var visible = cart.item_count - serviceQty(cart);
    if (visible < 0) {
      visible = 0;
    }
    paintingCount = true;
    var counts = document.querySelectorAll('cart-count');
    for (var i = 0; i < counts.length; i++) {
      if (counts[i].innerText.trim() !== String(visible)) {
        counts[i].innerText = String(visible);
      }
    }
    var dots = document.querySelectorAll('cart-dot');
    for (var j = 0; j < dots.length; j++) {
      dots[j].classList.toggle('is-visible', visible > 0);
    }
    paintingCount = false;
  }

  function watchCounts() {
    if (typeof MutationObserver === 'undefined') {
      return;
    }
    var observer = new MutationObserver(function () {
      if (paintingCount || !lastCart) {
        return;
      }
      paintCounts(lastCart);
    });
    var counts = document.querySelectorAll('cart-count');
    for (var i = 0; i < counts.length; i++) {
      observer.observe(counts[i], { childList: true, characterData: true, subtree: true });
    }
  }

  /* ------------------------------------------------------------------ *
   * Страховка на случай, если re:do всё же смонтируется
   * ------------------------------------------------------------------ */
  /* Их блоки помечены атрибутом data-target (info-card-container,
     coverage-button и т.д.) — в Prestige этого атрибута нет нигде, так что
     метка однозначная. Плюс восстанавливаем родную кнопку чекаута: их скрипт
     умеет её прятать (hideRedoProduct.checkoutButtonSelector='[name=checkout]'),
     и без этого покупатель остался бы вообще без кнопки. */
  function suppressRedoWidget() {
    var scopes = document.querySelectorAll('cart-drawer, .cart-page, .cart-drawer__footer, .cart-recap');
    for (var i = 0; i < scopes.length; i++) {
      var alien = scopes[i].querySelectorAll('[data-target], [id^="redo-"], [class^="redo-"]');
      for (var j = 0; j < alien.length; j++) {
        if (alien[j].closest('[data-cart-protect], [data-cart-returns]')) {
          continue;
        }
        if (alien[j].style.display !== 'none') {
          alien[j].style.display = 'none';
          alien[j].setAttribute('data-v-suppressed', '');
        }
      }
    }

    var buttons = document.querySelectorAll('form[action$="/cart"] [name="checkout"], .cart-drawer__footer [name="checkout"]');
    for (var k = 0; k < buttons.length; k++) {
      var style = window.getComputedStyle(buttons[k]);
      if (style.display === 'none' || style.visibility === 'hidden') {
        buttons[k].style.setProperty('display', '', 'important');
        buttons[k].style.setProperty('visibility', 'visible', 'important');
      }
    }
  }

  /* Их скрипт грузится отложенно: в теме стоит «Shopioso speed boost», который
     держит сторонние скрипты до первого движения покупателя. Значит блок может
     появиться в любой момент, а не только на наших событиях — следим за
     поверхностями корзины и переспрашиваем с дебаунсом. */
  var suppressTimer = null;

  function watchForRedoWidget() {
    if (typeof MutationObserver === 'undefined') {
      return;
    }
    var observer = new MutationObserver(function () {
      if (suppressTimer) {
        return;
      }
      suppressTimer = setTimeout(function () {
        suppressTimer = null;
        suppressRedoWidget();
      }, 200);
    });
    var scopes = document.querySelectorAll('cart-drawer, .cart-page, .cart-recap');
    for (var i = 0; i < scopes.length; i++) {
      observer.observe(scopes[i], { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
    }
  }

  /* ------------------------------------------------------------------ *
   * Синхронизация корзины (только страховка — возвраты едут на сабмите)
   * ------------------------------------------------------------------ */
  function announce(cart) {
    lastCart = cart;
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function removeLines(lines) {
    return lines.reduce(function (chain, line) {
      return chain.then(function () {
        return postCart('cart/change.js', { id: line.key, quantity: 0 });
      });
    }, Promise.resolve());
  }

  function addProtectTier(tier) {
    var c = config();
    var payload = { id: tier.id, quantity: 1 };
    if (c && c.protection && c.protection.disclaimer) {
      /* Navidium помечал свою строку этим property — оставляем таким же, чтобы
         строка в заказе выглядела как прежде. */
      payload.properties = { Disclaimer: c.protection.disclaimer };
    }
    return postCart('cart/add.js', payload);
  }

  /* Приводит корзину к состоянию «что выбрано, то и лежит»:
     выключено или нечего страховать → строк нет;
     включено → ровно одна строка нужного тира. */
  function sync(cart) {
    var c = config();
    if (!c || !c.protection || !cart || syncing) {
      if (cart) {
        paint(cart);
        lastCart = cart;
      }
      return Promise.resolve(cart);
    }

    var lines = protectLines(cart);
    var base = merchBase(cart);
    var on = desiredProtect(cart);
    var tier = targetTier(cart);
    var work = null;

    if (!on || base <= 0) {
      if (lines.length) {
        work = removeLines(lines);
      }
    } else if (!lines.length) {
      work = tier ? addProtectTier(tier) : null;
    } else if (lines.length > 1 || lines[0].quantity !== 1 || (tier && lines[0].variant_id !== tier.id)) {
      work = removeLines(lines).then(function () {
        return tier ? addProtectTier(tier) : null;
      });
    }

    if (!work) {
      paint(cart);
      lastCart = cart;
      reconcile(cart);
      return Promise.resolve(cart);
    }

    syncing = true;
    return work
      .then(function () { return getCart(); })
      .then(function (fresh) {
        syncing = false;
        paint(fresh);
        announce(fresh);
        reconcile(fresh);
        return fresh;
      })
      .catch(function (err) {
        syncing = false;
        if (window.console) {
          console.warn('[cart-services] sync failed', (err && err.message) || err);
        }
        return cart;
      });
  }

  function enqueue(task) {
    queue = queue.then(task).catch(function (err) {
      if (window.console) {
        console.warn('[cart-services]', (err && err.message) || err);
      }
    });
    return queue;
  }

  function syncFromServer() {
    return enqueue(function () {
      return getCart().then(sync);
    });
  }

  /* ------------------------------------------------------------------ *
   * Тумблеры
   * ------------------------------------------------------------------ */
  function writeAttr(name, value) {
    return setAttr(name, value);
  }

  function setAttr(name, value, after) {
    var attributes = {};
    attributes[name] = value;
    return enqueue(function () {
      return postCart('cart/update.js', { attributes: attributes }).then(after || sync);
    });
  }

  function onProtectToggle(input) {
    var c = config();
    if (!c || !c.protection) {
      return;
    }
    intent.protect = input.checked;
    intentFixes.protect = 0;
    var row = input.closest('[data-cart-protect]');
    if (row) {
      row.classList.toggle('is-on', input.checked);
    }
    setAttr(c.protection.attr, input.checked ? 'true' : 'false');
  }

  function onRedoToggle(input) {
    var c = config();
    if (!c || !c.redo) {
      return;
    }
    intent.redo = input.checked;
    intentFixes.redo = 0;
    var row = input.closest('[data-cart-returns]');
    if (row) {
      row.classList.toggle('is-on', input.checked);
    }
    var on = input.checked;
    /* Отказ обязан снести транзитную строку, если она осталась с прошлого
       захода в чекаут — иначе тумблер тут же вернулся бы во «включено». */
    setAttr(c.redo.attr, on ? 'true' : 'false', function (cart) {
      if (on) {
        return sync(cart);
      }
      return removeLines(redoLines(cart))
        .then(getCart)
        .then(function (fresh) {
          paint(fresh);
          announce(fresh);
          reconcile(fresh);
          return fresh;
        });
    });
  }

  document.addEventListener('change', function (e) {
    var target = e.target;
    if (!target || !target.closest) {
      return;
    }
    var protect = target.closest('[data-protect-toggle]');
    if (protect) {
      onProtectToggle(protect);
      return;
    }
    var redo = target.closest('[data-returns-toggle]');
    if (redo) {
      onRedoToggle(redo);
    }
  });

  /* ------------------------------------------------------------------ *
   * Инфо-модалки
   * ------------------------------------------------------------------ */
  function dialogPair(el) {
    /* Диалог ищем внутри СВОЕЙ строки: на /cart разметка отрисована дважды
       (страница и скрытый дровер) — глобальный поиск открыл бы копию в
       невидимом дровере. */
    var host = el.closest('[data-cart-protect], [data-cart-returns]');
    if (!host) {
      return null;
    }
    return host.querySelector('[data-protect-info], [data-returns-info]');
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) {
      return;
    }
    var open = e.target.closest('[data-protect-info-open], [data-returns-info-open]');
    if (open) {
      var dialog = dialogPair(open);
      if (dialog && dialog.showModal) {
        e.preventDefault();
        dialog.showModal();
      }
      return;
    }
    var close = e.target.closest('[data-protect-info-close], [data-returns-info-close]');
    if (close) {
      var openDialog = close.closest('[data-protect-info], [data-returns-info]');
      if (openDialog && openDialog.close) {
        e.preventDefault();
        openDialog.close();
      }
    }
  });

  /* ------------------------------------------------------------------ *
   * Переход в чекаут — строка возвратов
   * ------------------------------------------------------------------ */
  function addRedoLine() {
    var c = config();
    return fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: c.redo.target.id, quantity: 1 }),
      signal: timeoutSignal(8000)
    })
      .then(function (r) {
        if (r.ok) {
          return null;
        }
        return r
          .json()
          .catch(function () { return null; })
          .then(function (data) {
            if (window.console) {
              console.warn('[cart-services] returns line rejected', r.status, (data && data.description) || '');
            }
          });
      })
      .catch(function (err) {
        if (window.console) {
          console.warn('[cart-services] returns line failed', (err && err.message) || err);
        }
      });
  }

  /* Их виджет добавлял свой товар кликом по своей кнопке; их кнопки больше нет,
     значит шаг делаем мы: придержать сабмит, положить строку, уйти в чекаут.

     Гарды выстраданы на dev-теме (заказ #13896): без проверки defaultPrevented
     всплывший сабмит формы /cart/add с PDP уводил покупателя прямо в чекаут, а
     сравнение action по вхождению '/cart' матчило и продуктовую форму. */
  function onSubmit(e) {
    var c = config();
    if (!c || !c.redo || !c.redo.available || e.defaultPrevented) {
      return;
    }
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) {
      return;
    }
    if ((form.getAttribute('action') || '') !== root() + 'cart') {
      return;
    }
    var wantsRedo = !!document.querySelector('[data-returns-toggle]:checked');
    if (!wantsRedo) {
      return;
    }

    e.preventDefault();
    /* Решение принимаем по СВЕЖЕЙ корзине: кэш мог не увидеть последний ATC.
       Отказ запроса не роняет переход — покупатель уходит в чекаут в любом
       случае. */
    getCart()
      .catch(function () { return lastCart; })
      .then(function (cart) {
        if (cart && redoLines(cart).length) {
          return null;
        }
        return addRedoLine();
      })
      .then(function () {
        window.location.href = root() + 'checkout';
      });
  }

  document.addEventListener('submit', onSubmit);

  /* ------------------------------------------------------------------ *
   * Жизненный цикл
   * ------------------------------------------------------------------ */
  document.addEventListener('cart:change', function (e) {
    var cart = e.detail && e.detail.cart;
    if (cart) {
      /* Счётчик правим сразу (у темы обработчик асинхронный), а решение о
         строке принимаем только по СВЕЖЕЙ корзине: снимок из события мог
         устареть, пока в очереди шла наша собственная запись, и «строки нет»
         превратилось бы во второе добавление. */
      lastCart = cart;
      paintCounts(cart);
    }
    suppressRedoWidget();
    syncFromServer();
  });

  document.addEventListener('cart:refresh', function () {
    suppressRedoWidget();
    if (syncing) {
      return;
    }
    syncFromServer();
  });

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      syncFromServer();
    }
  });

  function start() {
    if (!config()) {
      return;
    }
    watchCounts();
    suppressRedoWidget();
    watchForRedoWidget();
    /* Первые секунды — ещё и по таймеру: наблюдатель ловит вставку только в уже
       существующие поверхности, а дровер тема пересобирает целиком. */
    setTimeout(suppressRedoWidget, 1500);
    setTimeout(suppressRedoWidget, 4000);
    syncFromServer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
